import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export interface Preferences {
  // CRT 视觉效果
  crtEnabled: boolean
  // 减弱动效(针对 prefer-reduced-motion)
  reduceMotion: boolean
  // 主题
  theme: 'neon-dark' | 'arcade-pink' | 'terminal-green' | 'light'
  // 像素缩放
  pixelScale: 'auto' | '1x' | '2x'
  // 排行默认条数
  leaderboardDefaultLimit: number
  // 自动提交分数
  autoSubmitScore: boolean
  // 音量 0-1
  volume: number
}

const DEFAULTS: Preferences = {
  crtEnabled: true,
  reduceMotion: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false,
  theme: 'neon-dark',
  pixelScale: 'auto',
  leaderboardDefaultLimit: 20,
  autoSubmitScore: true,
  volume: 0.7,
}

const STORAGE_KEY = 'ra_prefs'

function load(): Preferences {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...DEFAULTS }
    return { ...DEFAULTS, ...(JSON.parse(raw) as Partial<Preferences>) }
  } catch {
    return { ...DEFAULTS }
  }
}

export const usePreferencesStore = defineStore('preferences', () => {
  const prefs = ref<Preferences>(load())

  watch(prefs, v => localStorage.setItem(STORAGE_KEY, JSON.stringify(v)), { deep: true })

  function patch(partial: Partial<Preferences>) {
    prefs.value = { ...prefs.value, ...partial }
  }

  function reset() {
    prefs.value = { ...DEFAULTS }
  }

  return { prefs, patch, reset }
})
